'use client'

import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type TooltipProps = {
  multiplier: number
}

export default function Tooltip({ multiplier }: TooltipProps) {
  const { t } = useTranslation()
  const [focused, setFocused] = useState(false)

  return (
    <span
      className="absolute cursor-pointer w-fit text-center text-[white] flex flex-col gap-1 items-end z-10"
      style={{ top: 15, right: 15 }}
    >
      <p
        onPointerEnter={() => setFocused(true)}
        onPointerLeave={() => setFocused(false)}
        className="cursor-normal bg-[#25262B] cursor-default rounded-sm text-sm xs:text-base w-fit px-3 py-1"
      >
        {t('holdings.holdingCard.tooltip.multiplier', { multiplier })}
      </p>
      <p
        className={`bg-[#141517] rounded-sm text-xs xs:text-sm px-3 py-1 w-[90%] max-w-[12rem] ${focused ? 'animate-[fade-in_1s_ease-out]' : 'hidden'}`}
      >
        {t('holdings.holdingCard.tooltip.earned', { multiplier })}
      </p>
    </span>
  )
}
